import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import * as _ from "lodash";
import * as moment from "moment";
import { Observable, Subscription } from "rxjs";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import swal from "sweetalert2";
import { Store } from "@ngrx/store";
import * as fromRootStore from "../../../reducers";
import {
  CommonService,
  SubscribeService,
  TestingBillService,
} from "../../../services/index";
import * as fromCommonStore from "../../../store";

@Component({
  selector: "discount-approval-component",
  templateUrl: "./discountApproval.component.html",
})
export class discountApprovalComponent implements OnInit {
  modalRef: BsModalRef;
  @Input("tabTitle") title: string;
  @Input() active = false;
  @Input() isCloseable = false;
  @Input() dataContext;
  subscription: Subscription;
  branchCtrl: FormControl;
  isLoadMask: Promise<any>;
  discountApprovalData = [];
  isLoading: boolean = false;
  branchList: any[] = [];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  billTypeList = ["SERVICE"];
  filteredBranch: Observable<any[]>;
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "dis_id",
    orderDir: "DESC",
  };
  filterData = {
    search_name: "",
    from_date: new Date(),
    to_date: new Date(),
    srf_no: "",
    bill_type: "SERVICE",
    mod_discount: 0,
    description: "",
    oldDiscountAmt : 0
  };
  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  columns = [];
  toggleCol = [];
  printConfig: any;

  constructor(
    public modalService: BsModalService,
    public store: Store<fromRootStore.State>,
    private testingbillService: TestingBillService,
    public subscribeService: SubscribeService,
    private commonService: CommonService
  ) {
    this.branchCtrl = new FormControl();
    this.filteredBranch = this.branchCtrl.valueChanges
      .startWith(null)
      .map((name) =>
        name ? this.filterBranch(name) : this.branchList.slice()
      );
  }

  ngOnInit(): void {
    let that = this;
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        width: 70,
        minWidth: 70,
        maxWidth: 70,
        sortable: false,
        cellTemplate: this.snoTemplate,
      },
      { name: "SRF No", prop: "srf_no", width: 90, minWidth: 90, maxWidth: 90 },
      {
        name: "Date",
        prop: "added_on",
        width: 130,
        minWidth: 130,
        maxWidth: 130,
      },
      {
        name: "Client ID",
        prop: "client_no",
        width: 150,
        minWidth: 150,
        maxWidth: 150,
      },
      {
        name: "Name",
        prop: "client_name",
        width: 150,
        minWidth: 150,
        maxWidth: 150,
      },
      {
        name: "Branch",
        prop: "branch",
        width: 120,
        minWidth: 120,
        maxWidth: 120,
      },
      {
        name: "Bill amt",
        prop: "bill_amt",
        sortable: false,
        cellClass: "cell-right",
        width: 100,
        minWidth: 100,
        maxWidth: 100,
        toggle: true,
      },
      {
        name: "Discount",
        prop: "dis_approval_amt",
        sortable: false,
        cellClass: "cell-right",
        width: 100,
        minWidth: 100,
        maxWidth: 100,
        toggle: true,
      },
      { name: "Status", prop: "status", width: 90, minWidth: 90, maxWidth: 90 },
      {
        name: "Bill Status",
        prop: "bill_status",
        width: 90,
        minWidth: 90,
        maxWidth: 90,
      },
      {
        name: "Action",
        prop: "sno",
        width: 330,
        minWidth: 330,
        maxWidth: 330,
        sortable: false,
        cellClass: "cell-left",
        cellTemplate: this.editDeleteTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
    //THIS WILL WORK WHEN BILL SAVED IN OTHER TAB
    this.subscription = this.subscribeService
      .publishReloadTestingBillListGrid()
      .subscribe(($e) => {
        that.pageCallback({ offset: 0 });
      });

    //TO LOAD BRANCH COMBO
    this.subscription.add(
      this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
        if (_.isEmpty(res.data)) {
          return;
        }
        this.branchList = _.filter(res.data, function (obj) {
          return obj["is_crm_branch"] == "Yes";
        });
      })
    );
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getDiscountApprovalList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getDiscountApprovalList();
  }
  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }
  onChangePageSize(limit) {
    this.page.limit = limit;
    this.getDiscountApprovalList();
  }
  onOpenedFilter(): void {
    setTimeout(function () {
      $("#filterSearch").focus();
    }, 100);
  }
  filterBranch(name: string) {
    name = _.escapeRegExp(name);
    return this.branchList.filter((item) =>
      new RegExp(name, "gi").test(item.branch_name)
    );
  }
  applyFilter(): void {
    this.filterPanel.close();
    this.getDiscountApprovalList();
  }
  getDiscountApprovalList(): void {
    let that = this,
      params = {
        start: `${this.page.offset}`,
        limit: `${this.page.limit}`,
        orderColumn: `${this.page.orderBy}`,
        orderDir: `${this.page.orderDir}`,
        search_name: this.filterData["search_name"],
        srf_no: this.filterData["srf_no"],
        bill_type: this.filterData["bill_type"],
        branch_id: this.filterData["branch_id"],
        from_date: moment(this.filterData["from_date"]).format("YYYY-MM-DD"),
        to_date: moment(this.filterData["to_date"]).format("YYYY-MM-DD"),
      };

    this.isLoadMask = this.commonService
      .getDiscountApprovalList(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.discountApprovalData = res.data;
      });
  }
  modifyDiscount(discountModifyTemplate: TemplateRef<any>, row) {
    this.filterData.oldDiscountAmt = Number(row.dis_approval_amt);
    this.modalRef = this.modalService.show(discountModifyTemplate, {
      initialState: row,
    });
  }
  modifyApproveDiscountStatus(status, row) {
    let that = this;
    if (
      _.isEmpty(_.toString(that.filterData.description)) ||
      _.isEmpty(that.filterData.description)
    ) {
      swal("WARNING", "Discount amount or description is Empty");
      return;
    }
    if (that.filterData.mod_discount <= 0) {
      swal("WARNING", "Invalid Discount Amount");
      return;
    }
    this.changeDiscountStatus(status, row);
  }
  changeDiscountStatus(status, row) {
    console.log(this.filterData.oldDiscountAmt + "///" + row.dis_approval_amt);
    let that = this,
      params = {
        status: status,
        dis_id: row.dis_id,
        oldDiscountAmt : (that.filterData.oldDiscountAmt == 0)?row.dis_approval_amt:that.filterData.oldDiscountAmt,
        mod_discount : that.filterData.mod_discount,
        description : that.filterData.description
      };
    swal({
      title: "Are you sure to " + status + " this discount amount : " + row.dis_approval_amt,
      showCancelButton: true,
      confirmButtonText: "Yes!",
      cancelButtonText: "No",
    }).then(
      function () {
        that.loadingIndicator = true;
        that.isLoadMask = that.commonService
          .changeDiscountStatus(params)
          .then(function (res: any) {
            that.loadingIndicator = false;
            if (res.success) {
              that.filterData['mod_discount'] = 0;
              that.filterData['description'] = '';
              that.filterData['oldDiscountAmt'] = 0;
              that.getDiscountApprovalList();
              swal("Success", res.message, "success");
              that.modalRef.hide();
            } else {
              swal("ERROR", res.message, "error");
            }
          });
      },
      function (dismiss) {
        that.filterData.oldDiscountAmt = 0;
      }
    );
  }
  displayFn(branchID: any) {
    if (this.branchList != undefined) {
      if (branchID && this.branchList.length > 0) {
        let fitem = _.find(this.branchList, { branch_id: branchID });
        return fitem["branch_name"];
      }
    }
    return "";
  }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/getBillDiscountApproval/discountApproval.component.ts